import { HomePostEntity } from 'mk2/apps/home/schemas';

export const getHpID = (post: HomePostEntity): string => {
    if (post.isHomepagePost) {
        return `homepagePost:${post.id}`;
    } else {
        return `${post.type}:${post.id}`;
    }
};
